//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
// import TagManager from 'react-gtm-module';

//components
import Alerta from '../../../../../util/snackbars/.mixins/';
import Section from '../childrens/Section/.mixins';

//constrollers
import Permissao_controller from '../../../../../../controllers/permissao';
import Config from '../../../../../../controllers/config';

export default class Permissoes_ae extends Component {

    constructor(props) {
        super(props);

        this.child = React.createRef();

        this.state = {
            descricao: '',
            tipo: 'Adicionar',
            isLoading: true,
            isError: false,
            error: null
        }

        this.setState = this.setState.bind(this);
        this.validacao = this.validacao.bind(this);
        
        if (this.props && this.props.params && this.props.params.id)
            this.state.tipo = 'Editar';

        if (this.state.tipo === 'Editar')
            this.loadData();
    }

    async loadData() {

        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            const filters = {
                permissao_id_md5: this.props.params.id
            };
            const o_permissao = await Permissao_controller.getByID(token,filters);
            const j_permissao = JSON.parse(o_permissao.body);
            if (o_permissao.res.statusCode === 200) {
                this.setState({descricao: j_permissao.itens[0].descricao});

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:permissoes-ae',
                //       eventAction: 'callback',
                //       eventLabel: 'sucesso:getone-permissao',
                //     }
                // });
            } else {
                if (
                    j_permissao.status == false && 
                    j_permissao.message && 
                    j_permissao.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            this.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });
            this.child.current.retorno(this.state.error,'error');

            // TagManager.dataLayer({
            //     dataLayer: {
            //         event: 'event',
            //         eventCategory: 'tokstok:fornecedores:permissoes-ae',
            //         eventAction: 'callback',
            //         eventLabel: `erro:${error.message}`,
            //     }
            // });
        }
    }

    async validacao(props) {

        if (props.state.descricao === '')
            return props.child.current.retorno('Preencha o campo descrição!','warning');

        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            var json = null;
            
            if (props.state.tipo === 'Editar')
                json = JSON.parse(await Permissao_controller.put(token,props.state,props.props.params.id));
            else
                json = JSON.parse(await Permissao_controller.post(token,props.state));

            if (json.status) {
                props.child.current.retorno(json.message,'success');
                setTimeout(() => {
                    props.props.router.goBack();
                }, 1000);

                // TagManager.dataLayer({
                //     dataLayer: {
                //         event: 'event',
                //         eventCategory: 'tokstok:fornecedores:permissoes-ae',
                //         eventAction: 'callback',
                //         eventLabel: `sucesso:${json.message}`,
                //     }
                // });
            } else {
                if (
                    json.status == false && 
                    json.message && 
                    json.message.includes("Token inválido!")
                ) {
                    props.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });
            props.child.current.retorno(props.state.error,'error');

            // TagManager.dataLayer({
            //     dataLayer: {
            //         event: 'event',
            //         eventCategory: 'tokstok:fornecedores:permissoes-ae',
            //         eventAction: 'callback',
            //         eventLabel: `erro:${error.message}`,
            //     }
            // });
        }

    }

    render() {
        return (
            <div>
                <Section {...this}/>
                <Alerta ref={this.child}/>
            </div>
        );
    }
}